package one.healthium.log_food.ui.scanner.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultBarcodeScannerComponent(
    componentContext: ComponentContext,
    private val onBarcodeScanned: (String) -> Unit,
    private val onBackClicked: () -> Unit,
) : BarcodeScannerComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onBarcodeScanned(barcode: String) {
        onBarcodeScanned.invoke(barcode)
    }

    override fun onBackClicked() {
        onBackClicked.invoke()
    }
}